import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class DocumentService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/documents`;
  }

  private fileUploadUrl(): string {
    return `${this.configService.apiUrl()}/fileUpload`;
  }

  getDocumentList(docType): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getDocuments?docType=${docType}`;
    return this.http.get(REST_URL);
  }

  getApiURL(): string {
    return this.configService.apiUrl();
  }

  createDocument(document): Observable<any> {
    const REST_URL = `${this.baseUrl()}/createDocument`;
    return this.http.post(REST_URL, document);
  }

  updateDocument(document): Observable<any> {
    const REST_URL = `${this.baseUrl()}/updateDocument`;
    return this.http.post(REST_URL, document);
  }

  downloadFile(data: any): Observable<any> {
    const REST_URL = `${this.fileUploadUrl()}/genericFileDownload`;
    return this.http.post(REST_URL, data);
  }

  uploadDocumentFile(formData: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/uploadDocumentFile`;
    return this.http.post(REST_URL, formData);
  }

  deleteDocument(docType: string, uploadId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/deleteDocument`;
    return this.http.post(REST_URL, { docType, id: uploadId });
  }

  deleteNewsFile(file: any) : Observable<any>{
    const REST_URL = `${this.fileUploadUrl()}/genericFileDelete`;
    return this.http.post(REST_URL, { file });
  }
}
